export default __webpack_public_path__ + "static/media/telegram.26004122.png";